var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM63(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5438_45485",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5438_45485",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACF0lEQVRo3tWaTXKCQBCFZ+UJ3OkqSzwO23ADsiFbUrlDCKdJxV12WEUOQA6Bwg4mr01roUFLcIBpqr4qlL/3EHu6p1HKwPLw+rEEHojAGmRgCyqG1n94W8T7LtWUCwTMQQASUAPdETpmA57pXGMKX4AYlD1EX6Lkcy6GFD4DISgMCj+Hzv1C1zIt3gHpgMLP+QYrU+JdsBtR/AG6pnuHdE3ifY4ieiLo2k+kpc+d93tGF9OQBr/PY1NZIL75S7i3il9N9Mzf8p9wbgmVqYXiD6RXQyzHeW054bURthBgoGgdsXko10KI2xKzUpCB8iQB5KxSCyNoGtgINJA0i5FaoIF6XxRxdaSF4iku8aQaiBTXqVINrBUX21INZIpnDKQayJVlaXPnNFvlX6oCWih7A1vBBnIykAk2kJGBtWADn2QgEmwgIgOeYAMeGViCWqB40vw3w42VRKCB5FgP4EMg0EDQNDAHpSDxpPW0p4AvYkEG4n+zEvhyAQoB4kljeyMEG0IBBsKLM3PYOAOpxeJJ2/XuDXZwwM5C8aTJuWmGGju6lqXZpKVbtwYH+JaM0KTB795g0kcT1cR33tf6jk4ZP067iZ5510inkv/Y6cjRxjHaK+YQGw482BV8jdlgHXsesd8N504lpzLDvWrQYmTOWWzSM1rRMRs+x3gve1wwQ0XRI3ijOpUnCnKOIhWvZ1x/R1wFGnnd5hd83mG9WPHSoAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM63);
export default __webpack_public_path__ + "static/media/m63.018122a69bf35129383486208ac15db9.svg";
export { ForwardRef as ReactComponent };